import React from 'react'
import _ from 'lodash'
import {DetailsLegInfo} from './detailsleginfo.component'
import AccommodationsContainer from '../accommodations/accommodations.container'
import ActivitiesContainer from '../activities/activities.container'
import TravelContainer from '../travel/travel.container'
// import {ActivitiesOverview} from '../activities/activitiesoverview.component'
// import {TravelOverview} from '../travel/traveloverview.component'
import {LegOverview} from '../leg/legoverview.component'
import {LegPreview} from '../leg/legpreview.component'
import ViewDestinationContainer from '../init/destination/viewdestination.container'


export class DetailsOverview extends React.Component {
    constructor(props) {
        super(props)    

        console.log('DETAILS OVERVIEW')
        console.log(props)

        _.bindAll(this,
            'getContent'
        )
    }

    // componentWillReceiveProps(nextProps) {
    //   if (nextProps.detailStatus != this.state.detailStatus) {
    //     this.setState({detailStatus:nextProps.detailStatus})
    //   }
    // }

    getContent() {
  	switch (this.props.detailSection) {
            case this.props.availableDetailSections.DESTINATION:
                return <ViewDestinationContainer {...this.props} activeDestination={this.props.leg.get('destination')}/>
  		case this.props.availableDetailSections.OVERVIEW:
  			return <LegOverview
          {...this.props}/>
  		case this.props.availableDetailSections.ACCOMMODATIONS:        
  			return <AccommodationsContainer
          {...this.props}/>
  		case this.props.availableDetailSections.ACTIVITIES:       
                return <ActivitiesContainer
          {...this.props}/>
            case this.props.availableDetailSections.TRAVEL:        
                return <TravelContainer
          {...this.props}/>
            case this.props.availableDetailSections.LUNA:
            case this.props.availableDetailSections.AGENT:
                return 'LUNA Assist...'
  		default:
                if (this.props.leg) {
                    this.props.onChangeDetailsUI(this.props.availableDetailSections.OVERVIEW)
                    return ''
                } else {
    			return 'nothing selected in details'
                }
  	}
    }

    render() {
        return (
            <div>
                <DetailsLegInfo 
          {...this.props}/>
                {this.getContent()}
            </div>
        )
    }
}
